import { IInteriorProduct, IInteriorProductSubGroup } from "../../models/IChainInfo";
import { intersect, IObj2d, isInside } from "../../models/IObj";
import { InteriorProductType, IVec2d } from "../WebApiClient";
import { DragInfo, DragService, DragServiceProps } from "./DragService";
import { Section } from "./Section";

interface Pos {
    section: Section;
    product: IInteriorProduct;
    isValid: boolean;
}

/**For objects that only fit in top and bottom of sections.
 * These items are sold as a top+bottom set, so two items shoulde be displayed, and only one item is listed on the piecelist.

 * A set of top and bottom shelfs. Can only be ordered as a set.
 * There should be one item per set, and it should be placed at the top of a section.
 * For display purposes, the bottom part of the set should also be displayed on the bottom of visualizations.
 * */
export class DragServiceTopBottom extends DragService {

    private readonly possiblePositions: Pos[];

    constructor(props: DragServiceProps) {
        super(props);
        this.possiblePositions = this.getPossiblePositions(props);
    }

    getDragInfo(cursorModelPos: Readonly<IVec2d>, forceCopy: boolean): DragInfo | undefined {
        //find the section the cursor is in
        const bestPosition = this.possiblePositions.find(pp => isInside(cursorModelPos, pp.section));
        if (!bestPosition)
            return undefined;

        const itemY = bestPosition.section.position.y + bestPosition.section.size.y - bestPosition.product.defaultSize.y;

        const obj: IObj2d = {
            position: {
                x: bestPosition.section.position.x,
                y: itemY
            },
            size: {
                x: bestPosition.section.size.x,
                y: bestPosition.product.defaultSize.y
            }
        };
        if (this.baseState.otherItems.some(otherItem => intersect(obj, otherItem.item))) {
            return undefined;
        }

        return {
            ...obj,
            parentIndexes: [bestPosition.section.leftGable?.item.index, bestPosition.section.rightGable?.item.index].filter(idx => idx !== undefined) as number[],
            textureUrl: bestPosition.product.textureUrl,
            shadows: [],
            isFlipped: false,
            productId: bestPosition.product.id,
        };
    }

    private getPossiblePositions(props: DragServiceProps) {
        const result: Pos[] = [];
        for (let sect of this.baseState.sections) {
            if (sect.isModule)
                continue;
            const product = this.productSubGroup.products.find(p =>
                (p.defaultSize.x === sect.size.x
                || (p.minSize.x <= sect.size.x && p.maxSize.x >= sect.size.x)
                )
            );
            if (!product)
                continue;
            result.push({
                section: sect,
                product,
                isValid: true, //TODO find products that intersect
            });
            
        }
        return result;
    }


    static acceptable(pt: IInteriorProductSubGroup): boolean {
        return pt.productType === InteriorProductType.TopAndBottom;
    }

}
